import React from "react";
import FieldTextBox from "../../shared/controls/fieldTextBox";


const FiltroTalleresExternos = ({filtro, onChange}) => {
    return (
        <>
        <FieldTextBox name="nombre" label="Taller" colMd={2} value={filtro.nombre} onChange={onChange} />
      
        </>
    );
};

export default FiltroTalleresExternos;